import { Suspense } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import * as routes from 'router/routes';
import { USER_PERMISSIONS } from 'constants/userPermissions';
import { useCurrentUserInfo } from 'hooks/useCurrentUserInfo';
import { FullScreenLoader } from 'layouts';

const AccessControlRoute = ({
  allow = [USER_PERMISSIONS.ORGANISATION_ADMIN, USER_PERMISSIONS.SUPER_ADMIN],
  component: Component,
  ...rest
}) => {
  const { userPermissions } = useCurrentUserInfo(rest.computedMatch.params.organisationId);

  if (!userPermissions) {
    return <FullScreenLoader />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        allow.includes(userPermissions) ? (
          <Suspense key={rest.path} fallback={<FullScreenLoader />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect to={routes.home} />
        )
      }
    />
  );
};

AccessControlRoute.propTypes = {
  allow: PropTypes.arrayOf(PropTypes.oneOf(Object.values(USER_PERMISSIONS))),
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.any]).isRequired,
  location: PropTypes.shape({}),
};

export default AccessControlRoute;
